module.exports = __webpack_public_path__ + "files/138af7576f86f449e6205a3fdcf5c41f.png";